import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import autosize from 'autosize';

const classes = {
    tray: (focused) => classNames(
        'mt-2 px-2 py-2 border-t border-gray-100',
        {
            'bg-gray-50 rounded-b-lg': focused
        }
    ),
    wrapper: (focused, error) => classNames(
        'relative shadow-sm block w-full sm:text-sm border border-gray-300 rounded-md bg-white',
        {
            'ring-indigo-500 border-indigo-500': focused && ! error,
            'ring-red-500': focused && error,
            'border-red-500': error,
        }
    ),
    textarea: (extra) => classNames(
        extra,
        "block w-full bg-transparent border-none focus:ring-0"
    ),
    label: "block text-sm font-medium leading-5 text-gray-700",
    hint: "text-sm leading-5 text-gray-500",
    help: "ml-2 mt-2 text-sm text-gray-500"
};

export default class TextArea extends React.Component
{
    state = {
        focused: false
    };

    static propTypes = {
        id: PropTypes.string.isRequired,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        help: PropTypes.string,
        hint: PropTypes.string,
        error: PropTypes.bool,
        autosize: PropTypes.bool,

        tray: PropTypes.array,
    };

    static defaultProps = {
        label: '',
        placeholder: '',
        error: false,
        help: '',
        hint: '',
        autosize: true,

        tray: []
    };

    componentDidMount()
    {
        if (this.props.autosize) {
            setTimeout(() => autosize(this.textarea));
        }
    }

    onFocus = (e) => {
        this.setState({focused: true});
    };

    onBlur = (e) => {
        this.setState({focused: false});
    };

    render()
    {
        const {
            focused
        } = this.state;

        const {
            id,
            label,
            placeholder,
            help,
            hint,
            error,
            autosize,
            tray,
            className,
            ...otherProps
        } = this.props;

        return <>
            {
                ( label || hint ) && <div className="flex justify-between">
                    <Label name={id}>
                        {label}
                    </Label>
                    <Hint>
                        {hint}
                    </Hint>
                </div>
            }
            <div
                tabIndex='-1' // allows the div to get focus events, preventing focus loss if inner component is selected
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                className={classes.wrapper(focused, error)}
            >
                <textarea
                    id={id}
                    rows={3}
                    className={classes.textarea(className)}
                    placeholder={placeholder}
                    ref={ref => this.textarea = ref}
                    {...otherProps}
                />
                <Help>
                    {help}
                </Help>
                <Tray focused={focused}>
                    {tray}
                </Tray>
            </div>
        </>;
    }
}

const Label = ({name, children}) => children && <label htmlFor={name} className={classes.label}>
    {children}
</label>;

const Hint = ({children}) => children && <span className={classes.hint}>
    {children}
</span>

const Help = ({children}) => children && <p className={classes.help}>
    {children}
</p>;

const Tray = ({children, focused}) => children.length > 0 && <div className={classes.tray(focused)}>
    {children.map(child => React.cloneElement(child, { focused: focused }))}
</div>;
